import Keycloak from 'keycloak-js';

// Setup Keycloak instance as necessary
// Pass initialization options as required or leave blank to load from 'keycloak.json'
interface PortalWindow extends Window {
  PORTAL_IDP_AUTH_SERVER_URL?: string;
}

const portalWindow = window as PortalWindow;
const windowUrl = portalWindow.PORTAL_IDP_AUTH_SERVER_URL;
const envUrl: string | undefined = import.meta.env.VITE_IDP_AUTH_SERVER_URL;

let url: string | undefined;
if (typeof windowUrl === 'string' && windowUrl.trim() !== '') {
  url = windowUrl;
} else if (typeof envUrl === 'string' && envUrl.trim() !== '') {
  url = envUrl;
} else {
  url = undefined;
}

const keycloak = new Keycloak({
  clientId: 'piaas',
  realm: 'pan-net.cloud',
  url: url ?? '',
});

export default keycloak;
